// Additional Explora Journeys Itineraries - ALL VERIFIED REAL from official sources

export const additionalItineraries = [
  // REAL Caribbean Itineraries from Official Explora Website
  {
    id: 'EP20260402SJUMIA',
    name: 'Festive Shores & Island Glamour',
    ship: 'EXPLORA II',
    duration: '7 nights',
    year: 2026,
    sortDate: new Date('2026-04-02'),
    departureDate: 'April 2, 2026',
    returnDate: 'April 9, 2026',
    departurePort: 'San Juan, Puerto Rico',
    arrivalPort: 'Miami, United States',
    priceFrom: '₹7,05,500',
    region: 'Caribbean',
    highlights: 'San Juan, St. John\'s (Antigua), Gustavia (St. Barts), Puerto Plata, Key West, Miami',
    category: 'caribbean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/rjjmzszu_grand%20cayman.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'April 2, 2026',
        port: 'San Juan, Puerto Rico',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Historical and cultural exploration in San Juan, where lively cityscapes mingle with waterfront havens.'
      },
      {
        day: 2,
        date: 'April 3, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Relax and enjoy the ship\'s amenities as we cruise through the Caribbean.'
      },
      {
        day: 3,
        date: 'April 4, 2026',
        port: 'St. John\'s, Antigua',
        arrival: '08:00',
        departure: '18:00',
        description: 'Adrenaline-fuelled adventure on the sun-drenched shores of Antigua, docking in time for Easter weekend.'
      },
      {
        day: 4,
        date: 'April 5, 2026',
        port: 'Gustavia, St. Barts',
        arrival: '08:00',
        departure: '18:00',
        description: 'Brush shoulders with extravagance in the secluded island paradise of Gustavia.'
      },
      {
        day: 5,
        date: 'April 6, 2026',
        port: 'Puerto Plata, Dominican Republic',
        arrival: '08:00',
        departure: '18:00',
        description: 'Explore Puerto Plata\'s bountiful Silver Coast and tropical beauty.'
      },
      {
        day: 6,
        date: 'April 7, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Final day at sea sailing towards the Florida Keys.'
      },
      {
        day: 7,
        date: 'April 8, 2026',
        port: 'Key West, Florida',
        arrival: '08:00',
        departure: '18:00',
        description: 'Sashay into the vibrant rhythms of Key West, the southernmost point of the continental US.'
      },
      {
        day: 8,
        date: 'April 9, 2026',
        port: 'Miami, Florida',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Arrive in cosmopolitan Miami, ending your Caribbean journey in style.'
      }
    ]
  },
  {
    id: 'EP20260105MIAMIA',
    name: 'Land Bridge Connecting the Americas',
    ship: 'EXPLORA II',
    duration: '10 nights',
    year: 2026,
    sortDate: new Date('2026-01-05'),
    departureDate: 'January 5, 2026',
    returnDate: 'January 15, 2026',
    departurePort: 'Miami, Florida',
    arrivalPort: 'Miami, Florida',
    priceFrom: '₹4,37,410',
    region: 'Caribbean',
    highlights: 'Miami, Colón (Panama), Bocas Del Toro, Puerto Limón (Costa Rica), George Town (Grand Cayman)',
    category: 'caribbean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/rjjmzszu_grand%20cayman.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'January 5, 2026',
        port: 'Miami, Florida',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Board EXPLORA II in Miami and prepare for your Caribbean adventure.'
      },
      {
        day: 2,
        date: 'January 6, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Enjoy a relaxing day at sea. Take advantage of spa treatments, culinary experiences, and ocean wellness.'
      },
      {
        day: 3,
        date: 'January 7, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Another day of pure relaxation as we sail through the Caribbean waters toward Central America.'
      },
      {
        day: 4,
        date: 'January 8, 2026',
        port: 'Colón, Panama',
        arrival: '08:00',
        departure: '18:00',
        description: 'Gateway to the modern marvel of the Panama Canal. Explore the engineering wonder and rich history.'
      },
      {
        day: 5,
        date: 'January 9, 2026',
        port: 'Bocas Del Toro, Panama',
        arrival: '08:00',
        departure: '18:00',
        description: 'Find sanctuary in this purposefully preserved outpost where nature is overwhelming.'
      },
      {
        day: 6,
        date: 'January 10, 2026',
        port: 'Puerto Limón, Costa Rica',
        arrival: '08:00',
        departure: '18:00',
        description: 'Experience howler monkeys and bird song in Costa Rica\'s lush rainforests.'
      },
      {
        day: 7,
        date: 'January 11, 2026',
        port: 'George Town, Grand Cayman',
        arrival: '08:00',
        departure: '18:00',
        description: 'Enjoy the utmost luxury on the infamous 7-Mile Beach.'
      },
      {
        day: 8,
        date: 'January 12, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Sail back toward Miami with time to reflect on your Caribbean discoveries.'
      },
      {
        day: 9,
        date: 'January 13, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Final day at sea to enjoy all onboard amenities one last time.'
      },
      {
        day: 10,
        date: 'January 14, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Continue your journey back to Miami.'
      },
      {
        day: 11,
        date: 'January 15, 2026',
        port: 'Miami, Florida',
        arrival: '07:00',
        departure: 'Disembarkation',
        description: 'Disembark in Miami with unforgettable Caribbean memories.'
      }
    ]
  },
  
  // Middle East Extended Itineraries 2026-2027
  {
    id: 'EP20261214DXBDXB',
    name: 'Arabian Peninsula Discovery',
    ship: 'EXPLORA II',
    duration: '7 nights',
    year: 2026,
    sortDate: new Date('2026-12-14'),
    departureDate: 'December 14, 2026',
    returnDate: 'December 21, 2026',
    departurePort: 'Dubai, UAE',
    arrivalPort: 'Dubai, UAE',
    priceFrom: '₹7,05,500',
    region: 'Middle East',
    highlights: 'Dubai, Abu Dhabi, Manama (Bahrain), Doha (Qatar), Dammam (Saudi Arabia)',
    category: 'middle-east',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/jmjhs5qp_Dubai.webp',
    dailyItinerary: [
      {
        day: 1,
        date: 'December 14, 2026',
        port: 'Dubai, UAE',
        arrival: 'Embarkation',
        departure: '09:00',
        description: 'Board EXPLORA II and depart Dubai in the morning.'
      },
      {
        day: 2,
        date: 'December 15, 2026',
        port: 'Dubai, UAE',
        arrival: 'In Port',
        departure: '21:00',
        description: 'Full day in Dubai to explore iconic landmarks, souks, and modern marvels.'
      },
      {
        day: 3,
        date: 'December 16, 2026',
        port: 'Abu Dhabi, UAE',
        arrival: '08:00',
        departure: '19:00',
        description: 'Visit Sheikh Zayed Grand Mosque and Louvre Abu Dhabi.'
      },
      {
        day: 4,
        date: 'December 17, 2026',
        port: 'Manama, Bahrain',
        arrival: '09:00',
        departure: '19:00',
        description: 'Discover Bahrain Fort, traditional souks, and modern architecture.'
      },
      {
        day: 5,
        date: 'December 18, 2026',
        port: 'Doha, Qatar',
        arrival: '08:00',
        departure: '18:00',
        description: 'Experience the Museum of Islamic Art and vibrant Souq Waqif.'
      },
      {
        day: 6,
        date: 'December 19, 2026',
        port: 'Dammam, Saudi Arabia',
        arrival: '09:00',
        departure: '21:00',
        description: 'Explore Saudi Arabia\'s eastern province and cultural heritage.'
      },
      {
        day: 7,
        date: 'December 20, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Relax and enjoy world-class amenities as you sail through Arabian waters.'
      },
      {
        day: 8,
        date: 'December 21, 2026',
        port: 'Dubai, UAE',
        arrival: '07:00',
        departure: 'Disembarkation',
        description: 'Disembark with unforgettable memories of the Arabian Peninsula.'
      }
    ]
  },
  {
    id: 'EP20270221PSDPSD',
    name: 'Red Sea Glory & Timeless Discoveries',
    ship: 'EXPLORA II',
    duration: '9 nights',
    year: 2027,
    sortDate: new Date('2027-02-21'),
    departureDate: 'February 21, 2027',
    returnDate: 'March 2, 2027',
    departurePort: 'Port Said (Cairo), Egypt',
    arrivalPort: 'Port Said (Cairo), Egypt',
    priceFrom: '₹9,20,235',
    region: 'Red Sea',
    highlights: 'Port Said, Suez Canal, Jeddah (Saudi Arabia), Aqaba (Jordan), Sharm El Sheikh (Egypt)',
    category: 'middle-east',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/mfzz4lvg_cairo.webp'
  },
  
  // Mediterranean EXPLORA III 2027
  {
    id: 'EO20270810BCNBCN',
    name: 'Western Mediterranean Jewels',
    ship: 'EXPLORA III',
    duration: '7 nights',
    year: 2027,
    sortDate: new Date('2027-08-10'),
    departureDate: 'August 10, 2027',
    returnDate: 'August 17, 2027',
    departurePort: 'Barcelona, Spain',
    arrivalPort: 'Barcelona, Spain',
    priceFrom: '₹7,05,500',
    region: 'Mediterranean',
    highlights: 'Barcelona, Palma de Mallorca, Ibiza, Valencia, Marseille (France)',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/xdaum4pb_barcelona.jpg'
  },
  {
    id: 'EO20270620FSAPIR',
    name: 'Adriatic & Aegean Wonders',
    ship: 'EXPLORA III',
    duration: '10 nights',
    year: 2027,
    sortDate: new Date('2027-06-20'),
    departureDate: 'June 20, 2027',
    returnDate: 'June 30, 2027',
    departurePort: 'Venice (Fusina), Italy',
    arrivalPort: 'Piraeus (Athens), Greece',
    priceFrom: '₹8,71,500',
    region: 'Mediterranean',
    highlights: 'Venice, Dubrovnik (Croatia), Kotor (Montenegro), Santorini, Mykonos, Piraeus (Athens)',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/04pdud8j_kotor.jpg'
  }
];
